import React, { Component } from 'react';
import { Button } from '@material-ui/core';
import { connect } from 'react-redux';
import {
  searchCompanyOfficeList,
  searchCompanyHierarchyList,
  searchAreaHierarchyList,
  setCompanyHierarchyInfoList,
  setSelectedCompanyInfo,
  setHierarchyKbn,
  searchTreeOfficeList,
  setAdditionalItemFlg,
  searchAdditionalItemList,
} from '../../actions/CompanyAction';
import { setSystemLodingFLg } from '../../actions/CommonAction';
import CompanyTreeItemComponent from './CompanyTreeItemComponent';
import {
  HIERARCHY_KBN,
  FILTER_TAB_LIST,
  TREE_LEVEL,
} from '../../../common/const';
import './CompanyTreeListComponent.css';

class CompanyTreeListComponent extends Component {
  /**
   * 企業階層情報の検索を行い、検索結果を一時保存領域に保持する。
   */
  searchTreelist = async (selectHierarchyKbn) => {
    const {
      selectedCompanyInfo,
      searchCompanyOfficeListAct,
      searchCompanyHierarchyListAct,
      searchAreaHierarchyListAct,
      setHierarchyKbnAct,
      setSystemLodingFLgAct,
    } = this.props;

    // 未選択の場合何もしない
    if (!selectedCompanyInfo.kigyo_code) {
      return;
    }

    let ret = null;
    // ----- サーバアクセス中、画面を固定する START -----
    setSystemLodingFLgAct(true);
    if (selectHierarchyKbn === HIERARCHY_KBN.COMPANY) {
      // 企業階層
      ret = await searchCompanyOfficeListAct(selectedCompanyInfo.kigyo_code);
    } else if (selectHierarchyKbn === HIERARCHY_KBN.FUND) {
      // 出資率50%超
      ret = await searchCompanyHierarchyListAct(selectedCompanyInfo.kigyo_code);
    } else if (selectHierarchyKbn === HIERARCHY_KBN.AREA) {
      // 地域階層
      ret = await searchAreaHierarchyListAct(selectedCompanyInfo.kigyo_code);
    }
    // 検索結果が存在する場合
    if (ret) {
      // 階層情報区分値設定
      setHierarchyKbnAct(selectHierarchyKbn);
    }
    // ----- サーバアクセス中、画面を固定する END   -----
    setSystemLodingFLgAct(false);
  }

  /**
   * 企業階層ツリーから選択したItemの情報を取得し、選択中企業名、事業所詳細情報を表示する。
   */
  setSelectTreeItem = (ev) => {
    const {
      selectedCompanyInfo,
      setSelectedCompanyInfoAct,
    } = this.props;
    // データ属性から選択された企業情報を取得
    const { dataset } = ev.currentTarget;
    const selectCompanyDuns = dataset.companyDuns;
    const selectKigyoCode = dataset.kigyoCode;
    const selectCompanyTradeName = dataset.companyTradeName;
    const selectOfficeCode = dataset.officeCode;
    const selectId = dataset.id;

    // 選択中の企業、事業所が変更された場合
    if (selectedCompanyInfo.office_code !== selectOfficeCode
      || selectedCompanyInfo.id !== selectId) {
      const selectedCompanyInfoVal = {
        duns: selectCompanyDuns,
        kigyo_code: selectKigyoCode,
        trade_name: selectCompanyTradeName,
        office_code: selectOfficeCode,
        id: selectId,
      };
      // 選択中企業情報の一時保存領域を更新
      setSelectedCompanyInfoAct(selectedCompanyInfoVal);
    }
  }

  /**
   * 企業階層ツリーから選択したItemの「開く」ボタンのイベントから、事業所一覧の取得、表示を行う。
   */
  setTreeOfficeList = async (kigyoCode, level) => {
    const {
      searchTreeOfficeListAct,
      setSystemLodingFLgAct,
    } = this.props;

    // 企業コードを元に、事業所一覧を取得
    setSystemLodingFLgAct(true);
    await searchTreeOfficeListAct(kigyoCode, level);
    setSystemLodingFLgAct(false);
  }

  /**
   * 企業階層ツリーの「取引情報」リンクのイベントから、取引情報リストの取得、表示を行う。
   */
  setAdditionalItemList = async (item) => {
    const {
      searchAdditionalItemListAct,
      setSystemLodingFLgAct,
    } = this.props;
    // 事業所コードを元に、取引情報リストの取得しポップアップ画面を表示する
    setSystemLodingFLgAct(true);
    await searchAdditionalItemListAct(item);
    setSystemLodingFLgAct(false);
  }

  render() {
    const {
      selectedCompanyInfo,
      companyHierarchyInfoList,
      hierarchyKbn,
      areaHierarchyFlg,
      contractLabel,
    } = this.props;

    // Tab選択・未選択・非活性判定
    const tabElementList = [];
    // eslint-disable-next-line array-callback-return
    FILTER_TAB_LIST.map((filterTab) => {
      if (filterTab.id === hierarchyKbn) {
        // 選択している場合
        tabElementList.push(
          <Button
            key={filterTab.id}
            className={[
              'tab',
              hierarchyKbn === filterTab.id ? 'selected' : null,
            ].join(' ')}
            tabIndex="-1"
          >
            {filterTab.name}
          </Button>,
        );
      } else if (hierarchyKbn === null
        || (filterTab.id === HIERARCHY_KBN.AREA && areaHierarchyFlg === true)) {
        // 初期表示または非公開フラグがtrueの場合は非活性
        tabElementList.push(
          <Button
            key={filterTab.id}
            className={[
              'tab',
              hierarchyKbn === filterTab.id ? 'selected' : 'disabled',
            ].join(' ')}
            disabled={hierarchyKbn !== filterTab.id}
            tabIndex="-1"
          >
            {filterTab.name}
          </Button>,
        );
      } else {
        // 未選択の場合
        tabElementList.push(
          <Button
            key={filterTab.id}
            className={[
              'tab',
              hierarchyKbn === filterTab.id ? 'selected' : null,
            ].join(' ')}
            onClick={() => {
              this.searchTreelist(filterTab.id);
            }}
            tabIndex="-1"
          >
            {filterTab.name}
          </Button>,
        );
      }
    });

    return (
      <div className="companylist">
        <ul className="tabGroup">

          {tabElementList.map((tabElement) => (
            tabElement
          ))}
        </ul>
        <div className="companyArea">
          <div />
          <div className="companylistfield">
            <ul className="scroll scrollbar" tabIndex="-1">
              {companyHierarchyInfoList
                && hierarchyKbn
                && (
                  <CompanyTreeItemComponent
                    key={`${hierarchyKbn}-0`}
                    // 選択したタブ(企業階層、出資率50%超、地域階層)
                    tabType={hierarchyKbn}
                    // ツリーの階層
                    level={TREE_LEVEL.FIRST}
                    // レコードの識別子
                    id={`${hierarchyKbn}-0`}
                    // 企業/事業所リスト
                    item={companyHierarchyInfoList}
                    // 選択中企業企業情報をセットする関数
                    setSelectTreeItem={this.setSelectTreeItem}
                    // ツリーで選択したItemの事業所一覧を取得する関数
                    setTreeOfficeList={this.setTreeOfficeList}
                    // 選択企業情報
                    selectedCompanyInfo={selectedCompanyInfo}
                    // 取引情報ポップアップ画面を表示する関数
                    setAdditionalItemList={this.setAdditionalItemList}
                    // 契約ラベル
                    contractLabel={contractLabel}
                  />
                )}
            </ul>
          </div>
        </div>
      </div>
    );
  }
}

export default connect(
  (state) => ({
    hierarchyKbn: state.company.hierarchyKbn,
    selectedCompanyInfo: state.company.selectedCompanyInfo,
    companyHierarchyInfoList: state.company.companyHierarchyInfoList,
    areaHierarchyFlg: state.company.areaHierarchyFlg,
    contractLabel: state.common.contractLabel,
  }),
  (dispatch) => ({
    searchCompanyOfficeListAct: (str) => dispatch(searchCompanyOfficeList(str)),
    searchCompanyHierarchyListAct: (str) => dispatch(searchCompanyHierarchyList(str)),
    searchAreaHierarchyListAct: (str) => dispatch(searchAreaHierarchyList(str)),
    setCompanyHierarchyInfoListAct: (obj) => dispatch(setCompanyHierarchyInfoList(obj)),
    setHierarchyKbnAct: (str) => dispatch(setHierarchyKbn(str)),
    setSelectedCompanyInfoAct: (obj) => dispatch(setSelectedCompanyInfo(obj)),
    setSystemLodingFLgAct: (bool) => dispatch(setSystemLodingFLg(bool)),
    searchTreeOfficeListAct: (str, number) => dispatch(searchTreeOfficeList(str, number)),
    setAdditionalItemFlgAct: (bool) => dispatch(setAdditionalItemFlg(bool)),
    searchAdditionalItemListAct: (str) => dispatch(searchAdditionalItemList(str)),
  }),
)(CompanyTreeListComponent);
